import { rawOAuth } from "../../utils";

/**
 * Submit feedback (thumbs up / thumbs down) for a generated mockup.
 *
 * @param jobId   Single-item mockup job ID, or bulk orchestration job ID
 * @param value   1 for positive (thumbs up), 0 for negative (thumbs down)
 * @param itemId  Required for bulk jobs (trace is stored per item in items_trace_json)
 */
export async function submitMockupFeedback(
  jobId: string,
  value: number,
  itemId?: string,
): Promise<void> {
  const body: Record<string, string | number> = {
    actionName: "submit_feedback",
    job_id: jobId,
    value,
  };
  if (itemId) {
    body.item_id = itemId;
  }
  const res = await rawOAuth(
    "POST",
    "mockup-generation",
    null,
    body,
    { Accept: "application/json" },
  );
  if (!res.ok) {
    const json = await res.json().catch(() => null);
    const message = (json as Record<string, unknown>)?.error ?? "Failed to submit feedback";
    throw new Error(String(message));
  }
}

/**
 * Fire-and-forget helper used by popup components to send mockup feedback.
 * Converts a boolean (positive/negative) to the numeric value expected by the API.
 *
 * @param itemId  Pass for bulk mockup jobs so the backend can resolve the per-item trace_id
 */
export function sendMockupFeedback(
  jobId: string | null,
  isPositive: boolean,
  itemId?: string,
): void {
  if (!jobId) return;
  submitMockupFeedback(jobId, isPositive ? 1 : 0, itemId).catch((err) => {
    console.error("Failed to submit mockup feedback:", err);
  });
}
